// Hooks / Node modules / Styles
import { Footer } from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components
import SocialMediaItemGroup from "./com/SocialMediaItemGroup";

// Data / Images / Icons

const FooterLink = ({ link, text }) => {
  return (
    <li>
      <a
        href={link}
        className="text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors duration-200"
      >
        {text}
      </a>
    </li>
  );
};

function CustomFooter() {
  return (
    <Footer styles="bg-gray-100 dark:bg-dark-700 text-gray-700 py-10">
      <div className="container mx-auto flex flex-col items-center">
        {/* Quick Links */}
        <nav className="mb-4">
          <ul className="flex space-x-6 text-sm">
            <li>
              <FooterLink link="/" text="Home" />
            </li>
            <li>
              <FooterLink link="/experience" text="Experience" />
            </li>
            <li>
              <FooterLink link="/contact" text="Contact" />
            </li>
          </ul>
        </nav>

        {/* Social Media Links */}
        <div className="my-10">
          <SocialMediaItemGroup />
        </div>

        {/* Copyright */}
        <p className="text-sm text-gray-500">
          © {new Date().getFullYear()} Dhanushka Sandakelum. All rights
          reserved.
        </p>
      </div>
    </Footer>
  );
}

export default CustomFooter;
